import { configureStore } from "@reduxjs/toolkit";
// import userReducer from "./slice/user";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";

import uploadFileModuleReducer from "redux/slice/uploadFileModule";
import medicalFlowModuleReducer from "redux/slice/medicalFlowModule";
import userReducer from "redux/slice/user";

const rootReducer = combineReducers({
  uploadFileModule: uploadFileModuleReducer,
  medicalFlowModule: medicalFlowModuleReducer,
  userData: userReducer,
});

const persistConfig = {
  key: "rootsss",
  version: 1,
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
